import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import styled from 'styled-components';

const ListaEmpresas = ({ negocios, documentosNegocios }) => {
    const navigate = useNavigate();

    const handleClickEmpresa = (empresaId) => {
        const params = new URLSearchParams();
        params.set('tipo', 'empresa');
        params.set('id', empresaId);
        navigate(`?${params.toString()}`);
    };

    return (
        <Box sx={{ padding: '20px 0' }}>
            <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mb: 3 }}>
                Selecciona un Negocio
            </Typography>
            <Grid container spacing={3}>
                {negocios.map((negocio) => (
                    <Grid item xs={12} sm={6} md={4} key={negocio.Id}>
                        <CardEmpresa
                            elevation={2}
                            onClick={() => handleClickEmpresa(negocio.Id)}
                        >
                            <CardContent sx={{ textAlign: 'center', padding: '30px 20px !important' }}>
                                {negocio.logo ? (
                                    <>
                                        <LogoGrande>
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}/api/negocio/logo/${negocio.logo}`}
                                                alt={negocio.nombre}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain'
                                                }}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.parentElement.style.display = 'none';
                                                }}
                                            />
                                        </LogoGrande>
                                        <ContadorDocs>
                                            {documentosNegocios[negocio.Id] || 0}
                                        </ContadorDocs>
                                        <Typography variant="body2" color="textSecondary">
                                            Documentos
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        <IconoEmpresa>
                                            <BusinessIcon />
                                        </IconoEmpresa>
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            gutterBottom
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                minHeight: '50px'
                                            }}
                                        >
                                            {negocio.nombre}
                                        </Typography>
                                        <ContadorDocs>
                                            {documentosNegocios[negocio.Id] || 0}
                                        </ContadorDocs>
                                        <Typography variant="body2" color="textSecondary">
                                            Documentos
                                        </Typography>
                                    </>
                                )}
                            </CardContent>
                        </CardEmpresa>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

const CardEmpresa = styled(Card)`
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 15px !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
    height: 100%;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 24px rgba(0, 60, 102, 0.2) !important;
    }
`;

const IconoEmpresa = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #336385;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 15px;
    box-shadow: 0 4px 12px rgba(0, 60, 102, 0.3);

    svg {
        font-size: 35px;
        color: white;
    }
`;

const LogoGrande = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
    margin-bottom: 15px;
`;

const ContadorDocs = styled.div`
    font-size: 36px;
    font-weight: 800;
    background: #336385;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 10px 0;
`;

export default ListaEmpresas;
